import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';
import { STATE_CHANGES_FIELD } from '@utils/reusableGraphQLFields';

export type FetchTransfersPermissions = {
  canReadBankAccountDisclosed: boolean;
  canReadAlertReportBasic: boolean;
  canWriteAlertReportBasic: boolean;
  canReadClientLowRiskPii: boolean;
};

export const FETCH_TRANSFERS_QUERY = ({
  canReadBankAccountDisclosed,
  canReadAlertReportBasic,
  canWriteAlertReportBasic,
  canReadClientLowRiskPii,
}: FetchTransfersPermissions) => `query fetchTransfers($input: FetchTransfersInput!) {
  fetchTransfers(input: $input) {
    transfers {
      id
      amountCents
      initiatedByRepresentative
      state
      type
      source
      sourceId
      ${STATE_CHANGES_FIELD}
      instantInvest
      dividendFor {
        ticker
      }
      fromSubAccount {
        id
        account {
          type
        }
      }
      failReason
      cancelReason
      cancelReconciledReason
      bankAccount {
        id
        name
        institutionNumber
        bankAccountNumber
        transitNumber
        ${canReadBankAccountDisclosed ? 'transitNumberDisclosed' : ''}
        ${canReadBankAccountDisclosed ? 'bankAccountNumberDisclosed' : ''}
      }
      isWithdrawAll
      ${canReadAlertReportBasic ? 'isSuspicious' : ''}
      ${
        canWriteAlertReportBasic
          ? `
        alertReport {
          id
          rules {
            type
            translatedDescription { ${TRANSLATED_STRING_FIELDS} }
          }
        }
      `
          : ''
      }
      subAccount {
        id
        account {
          id
          type
          user {
            id
            type
            entityName
            ${canReadClientLowRiskPii ? 'firstName middleName lastName' : ''}
          }
          organization {
            id
          }
        }
        goal {
          name
        }
        financialProduct {
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        statistics {
          marketValueCents
          moneyAvailableCents
          availableFundsToWithdrawCents
        }
      }
      createdAt
      reconciledAt
      isRecurring
      manualProcess {
        id
        type
        signedUrl
        institution { name }
        transferAccount
        transferAccountNumber
        transferMethod
      }
      fiscalDate
      usaContributionType
      usaWithdrawalReason
    }
    totalCount
  }
}`;

export const FETCH_TRANSFERS = (permissions: FetchTransfersPermissions) =>
  gql`${FETCH_TRANSFERS_QUERY(permissions)}`;
